var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _rect9, _path2, _rect10, _circle, _rect11, _rect12, _path3, _rect13, _path4, _rect14, _circle2, _rect15, _rect16, _path5, _rect17, _path6, _rect18, _ellipse, _circle3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCollectionDark = function SvgCollectionDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 160,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 24,
    width: 112,
    height: 112,
    rx: 56,
    fill: "#1D192D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.75,
    y: 10.75,
    width: 138.5,
    height: 138.5,
    rx: 69.25,
    stroke: "#fff",
    strokeOpacity: 0.05,
    strokeWidth: 1.5,
    strokeDasharray: "2 2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 116,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#1D192D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 14,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#1D192D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 30,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#1D192D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 139,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#1D192D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 60,
    width: 80,
    height: 48,
    rx: 10,
    fill: "#110D21",
    fillOpacity: 0.32
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 100.75,
    y: 56.75,
    width: 78.5,
    height: 46.5,
    rx: 9.25,
    fill: "#1D192D",
    stroke: "#322E43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.75 66a9.25 9.25 0 0 1 9.25-9.25h60a9.25 9.25 0 0 1 9.25 9.25v21.25h-78.5V66Z",
    fill: "#272339",
    stroke: "#322E43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 106.75,
    y: 66.75,
    width: 22.5,
    height: 22.5,
    rx: 5.25,
    fill: "#1D192D",
    stroke: "#322E43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.843 80.62c1.196 1.281.285 3.371-1.468 3.366l-5.749-.017c-1.752-.005-2.651-2.1-1.447-3.374l2.884-3.05a2 2 0 0 1 2.915.01l2.865 3.066Z",
    fill: "#56516A"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 94,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#322E43"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 74,
    r: 2,
    fill: "#56516A"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 60,
    width: 80,
    height: 48,
    rx: 10,
    fill: "#110D21",
    fillOpacity: 0.32
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 20.75,
    y: 56.75,
    width: 78.5,
    height: 46.5,
    rx: 9.25,
    fill: "#1D192D",
    stroke: "#322E43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 66A9.25 9.25 0 0 1 30 56.75h60A9.25 9.25 0 0 1 99.25 66v21.25h-78.5V66Z",
    fill: "#272339",
    stroke: "#322E43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 26.75,
    y: 66.75,
    width: 22.5,
    height: 22.5,
    rx: 5.25,
    fill: "#1D192D",
    stroke: "#322E43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.843 80.62c1.196 1.281.285 3.371-1.468 3.366l-5.75-.017c-1.751-.005-2.65-2.1-1.446-3.374l2.884-3.05a2 2 0 0 1 2.915.01l2.865 3.066Z",
    fill: "#56516A"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 94,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#322E43"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 74,
    r: 2,
    fill: "#56516A"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 40.6,
    y: 52.5,
    width: 108,
    height: 66,
    rx: 10,
    fill: "#110D21",
    fillOpacity: 0.32
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 46.75,
    y: 47.75,
    width: 106.5,
    height: 64.5,
    rx: 9.25,
    fill: "#1D192D",
    stroke: "#322E43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.75 57A9.25 9.25 0 0 1 56 47.75h88a9.25 9.25 0 0 1 9.25 9.25v33.25H46.75V57Z",
    fill: "#272339",
    stroke: "#322E43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 54.85,
    y: 61.5,
    width: 30.9,
    height: 31.5,
    rx: 5.25,
    fill: "#1D192D",
    stroke: "#322E43",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.013 82.134c1.178 1.285.263 3.358-1.48 3.352l-11.115-.033c-1.743-.005-2.646-2.084-1.46-3.361l5.576-6.004a2 2 0 0 1 2.94.009l5.538 6.037Z",
    fill: "#56516A"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 54.1,
    y: 99.25,
    width: 43.2,
    height: 5.5,
    rx: 2.75,
    fill: "#322E43"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.9,
    cy: 71.75,
    rx: 2.7,
    ry: 2.75,
    fill: "#56516A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 80,
    r: 80,
    fill: "url(#collection-dark_svg__a)",
    fillOpacity: 0.04
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "collection-dark_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100.552 80.552) scale(79.4483)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6695FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6695FF",
    stopOpacity: 0
  })))));
};

export { SvgCollectionDark as ReactComponent };
export default "data:image/svg+xml;base64,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";